module.exports = __webpack_public_path__ + "static/img/ycz.8558b3e.svg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/image/ycz.svg
// module id = LT5/
// module chunks = 0